import { render, staticRenderFns } from "./sponsor-site-info.vue?vue&type=template&id=082cd57f&scoped=true"
import script from "./sponsor-site-info.vue?vue&type=script&lang=ts"
export * from "./sponsor-site-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082cd57f",
  null
  
)

export default component.exports